import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';
import MultiSelectDropDownConfig from './MultiSelectDropDownConfig';

export default class QuestionConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.ChildObject(MultiSelectDropDownConfig, true)
    public multiSelectDropDown: MultiSelectDropDownConfig | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<QuestionConfig>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Question Config";
    }
}